/**
 * Homepage Google reviews injector.
 * Loaded on the live theme as mdb-defer-third-party.js (orphaned include).
 * Replaces the homepage Elfsight reviews embed when Liquid/JSON sync is stuck.
 *
 * Also bootstraps Clean & Box draft PDP preview when ?view=clean-box-draft
 * (does not assign templates / does not change live product pages).
 */
(function () {
  // --- Draft PDP preview bootstrap (runs immediately on matching product URLs) ---
  (function loadPdpPreview() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      var view = (params.get('view') || '').toLowerCase();
      var flag = (params.get('mdb_pdp') || '').toLowerCase();
      var wants =
        view === 'clean-box-draft' ||
        view.indexOf('clean-box') !== -1 ||
        flag === 'draft' ||
        flag === '1';
      if (!wants || !/\/products\//.test(window.location.pathname)) return;
      if (window.__mdbPdpPreviewScript) return;
      window.__mdbPdpPreviewScript = true;
      var sample = document.querySelector(
        'script[src*="/cdn/shop/t/"][src*="/assets/"], link[href*="/cdn/shop/t/"][href*="/assets/"]'
      );
      var href = '/cdn/shop/t/28/assets/mdb-pdp-preview-v5.js';
      if (sample) {
        href = (sample.src || sample.href).replace(/\/assets\/[^/?#]+.*/, '/assets/mdb-pdp-preview-v5.js');
      }
      var s = document.createElement('script');
      s.src = href + (href.indexOf('?') === -1 ? '?v=draft2' : '&v=draft2');
      s.async = false;
      document.head.appendChild(s);
    } catch (e) {}
  })();

  var ELF_REVIEWS_CLASS = 'elfsight-app-537705c8-c91d-42ed-8a06-6b5a5be0e1e8';
  var CSS_HREF_PATH = 'section-mdb-google-reviews.css';
  var SLIDER_CSS_PATH = 'component-slider.css';

  var REVIEWS = [
    {
      quote:
        'Highly recommend this awesome service to all brides! Gown is like brand new and presented beautifully in a gorgeous box with lace trim. Perfect for storage. They even helped to store my veil & accessories. Website easy to use and service received online & in person was top notch!',
      author: 'Vanessa Mitchell',
      location: 'Australia',
    },
    {
      quote:
        'MyDressbox is absolutely amazing! My dress came back brand new and beautifully boxed. The customer service was beyond perfect. I couldn’t ask for anything more and highly recommend this service to all brides.',
      author: 'Alanah C.',
      location: 'Taylors Lakes, VIC',
    },
    {
      quote:
        'After our big day I started googling wedding dress dry cleaning and was appalled at how ridiculously expensive it was. Luckily I stumbled across MyDressbox — the process was super easy and they kept in contact throughout. My dress arrived back lovely and clean and beautifully packaged in a box.',
      author: 'Jessie U.',
      location: 'NSW',
    },
    {
      quote:
        'The process was super easy. I bought the service I needed, received the box with instructions, chucked my dress in and it came back in a pretty box all clean. My dress had a crazy amount of tulle and beads but it all came back clean and as beautiful as it was the day I wore it.',
      author: 'Soulla M.',
      location: 'QLD',
    },
    {
      quote:
        'As a bridal designer and boutique owner I highly recommend getting your gown cleaned by MyDressbox. Excellent results every time — gowns are handled with the utmost care, including minor repairs like fixing falling beads. Affordable, with a faster turnaround than traditional dry cleaning.',
      author: 'Shezarin Batha Couture',
      location: 'Melbourne, VIC',
    },
  ];

  function assetUrl(filename) {
    var existing = document.querySelector('link[href*="/assets/' + filename + '"], script[src*="/assets/"]');
    var sample = document.querySelector('script[src*="/cdn/shop/t/"][src*="/assets/"]');
    if (sample) {
      return sample.src.replace(/\/assets\/[^/?#]+.*/, '/assets/' + filename);
    }
    var link = document.querySelector('link[href*="/cdn/shop/t/"][href*="/assets/"]');
    if (link) {
      return link.href.replace(/\/assets\/[^/?#]+.*/, '/assets/' + filename);
    }
    return '/cdn/shop/t/28/assets/' + filename;
  }

  function ensureStylesheet(filename) {
    if (document.querySelector('link[href*="/assets/' + filename + '"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = assetUrl(filename);
    document.head.appendChild(link);
  }

  function starsSvg() {
    var html = '';
    for (var i = 0; i < 5; i++) {
      html +=
        '<svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 17.3 18.2 21l-1.6-7.1L22 9.2l-7.2-.6L12 2 9.2 8.6 2 9.2l5.4 4.7L5.8 21z"/></svg>';
    }
    return html;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function reviewCard(review, index) {
    return (
      '<li id="Slide-mdb-home-reviews-' +
      (index + 1) +
      '" class="mdb-g-reviews__item grid__item slider__slide">' +
      '<article class="mdb-g-reviews__review" style="background:#efecec;border-radius:6px;padding:2.5rem 1.75rem;box-sizing:border-box;">' +
      '<span class="mdb-g-reviews__verified">' +
      '<svg class="mdb-g-reviews__verified-icon" width="16" height="16" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<circle cx="12" cy="12" r="12" fill="#188038"></circle>' +
      '<path fill="#ffffff" d="M10.1 16.6 6.2 12.7l1.4-1.4 2.5 2.5 6.1-6.1 1.4 1.4z"></path>' +
      '</svg>' +
      '<span class="mdb-g-reviews__verified-text">Verified Google review</span>' +
      '</span>' +
      '<blockquote class="mdb-g-reviews__quote is-clamped" data-mdb-quote>' +
      '<p class="mdb-g-reviews__quote-text">' +
      escapeHtml(review.quote) +
      '</p>' +
      '<button type="button" class="mdb-g-reviews__read-more" data-mdb-quote-toggle hidden aria-expanded="false">Read more</button>' +
      '</blockquote>' +
      '<p class="mdb-g-reviews__stars mdb-g-reviews__stars--review" aria-label="5 out of 5 stars">' +
      starsSvg() +
      '</p>' +
      '<footer class="mdb-g-reviews__meta">' +
      '<cite class="mdb-g-reviews__author">' +
      escapeHtml(review.author) +
      '</cite>' +
      '<span class="mdb-g-reviews__location">' +
      escapeHtml(review.location) +
      '</span>' +
      '<span class="mdb-g-reviews__source">Posted on Google</span>' +
      '</footer>' +
      '</article>' +
      '</li>'
    );
  }

  function buildMarkup(reviewsLink) {
    var slides = REVIEWS.map(reviewCard).join('');
    return (
      '<div class="mdb-g-reviews">' +
      '<div class="page-width mdb-g-reviews__intro">' +
      '<h2 class="mdb-g-reviews__heading h2">What our brides say</h2>' +
      '<p class="mdb-g-reviews__subheading">Real Google reviews from brides who trusted us with their gowns.</p>' +
      '<a class="mdb-g-reviews__summary" href="' +
      escapeHtml(reviewsLink) +
      '" aria-label="Google rating 4.9 based on 160+ reviews. View reviews.">' +
      '<span class="mdb-g-reviews__summary-logo" aria-hidden="true">' +
      '<svg width="22" height="22" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" focusable="false">' +
      '<path fill="#FFC107" d="M43.6 20.1H42V20H24v8h11.3C33.7 32.7 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34.2 6.1 29.4 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.6-.4-3.9z"/>' +
      '<path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34.2 6.1 29.4 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>' +
      '<path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.3 35.5 26.8 36 24 36c-5.3 0-9.7-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/>' +
      '<path fill="#1976D2" d="M43.6 20.1H42V20H24v8h11.3c-1.1 3.1-3.5 5.5-6.5 6.6l.1.1 6.2 5.2C36.5 40.7 44 35 44 24c0-1.3-.1-2.6-.4-3.9z"/>' +
      '</svg></span>' +
      '<span class="mdb-g-reviews__summary-text">' +
      '<span class="mdb-g-reviews__summary-label">Google rating</span>' +
      '<span class="mdb-g-reviews__summary-row">' +
      '<span class="mdb-g-reviews__summary-score">4.9</span>' +
      '<span class="mdb-g-reviews__stars" aria-hidden="true">' +
      starsSvg() +
      '</span></span>' +
      '<span class="mdb-g-reviews__summary-count">Based on 160+ reviews</span>' +
      '</span></a></div>' +
      '<slider-component class="slider-mobile-gutter slider-component-desktop page-width mdb-g-reviews__slider">' +
      '<ul id="Slider-mdb-home-reviews" class="mdb-g-reviews__list grid grid--1-col-tablet-down grid--3-col-desktop slider slider--tablet slider--desktop" role="list" aria-label="What our brides say">' +
      slides +
      '</ul>' +
      '<div class="slider-buttons no-js-hidden">' +
      '<button type="button" class="slider-button slider-button--prev" name="previous" aria-label="Previous review">' +
      '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708z" clip-rule="evenodd"/></svg>' +
      '</button>' +
      '<button type="button" class="slider-button slider-button--next" name="next" aria-label="Next review">' +
      '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708z" clip-rule="evenodd"/></svg>' +
      '</button>' +
      '</div></slider-component>' +
      '<div class="page-width mdb-g-reviews__cta">' +
      '<a class="button button--secondary" href="' +
      escapeHtml(reviewsLink) +
      '">Read more reviews</a></div></div>'
    );
  }

  function initQuoteToggles(root) {
    root.querySelectorAll('[data-mdb-quote]').forEach(function (quote) {
      if (quote.dataset.mdbQuoteReady === 'true') return;
      var text = quote.querySelector('.mdb-g-reviews__quote-text');
      var button = quote.querySelector('[data-mdb-quote-toggle]');
      if (!text || !button) return;
      quote.dataset.mdbQuoteReady = 'true';
      quote.classList.add('is-clamped');
      var measure = function () {
        var wasExpanded = !quote.classList.contains('is-clamped');
        if (wasExpanded) quote.classList.add('is-clamped');
        var overflows = text.scrollHeight > text.clientHeight + 1;
        button.hidden = !overflows && !wasExpanded;
        if (wasExpanded) {
          quote.classList.remove('is-clamped');
          button.hidden = false;
          button.textContent = 'Read less';
          button.setAttribute('aria-expanded', 'true');
        } else {
          button.textContent = 'Read more';
          button.setAttribute('aria-expanded', 'false');
        }
      };
      button.addEventListener('click', function () {
        quote.classList.toggle('is-clamped');
        var expanded = !quote.classList.contains('is-clamped');
        button.textContent = expanded ? 'Read less' : 'Read more';
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
      measure();
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(measure).catch(function () {});
      }
      window.addEventListener('resize', measure);
    });
  }

  function hideEmptyBridesHeading() {
    document.querySelectorAll('h2').forEach(function (h2) {
      var text = (h2.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (text.indexOf('what our brides say') === -1) return;
      var section = h2.closest('.shopify-section');
      if (!section) return;
      // Only hide the empty leftover multicolumn, not our injected block
      if (section.querySelector('.mdb-g-reviews')) return;
      if (section.querySelector('.' + ELF_REVIEWS_CLASS)) return;
      section.style.display = 'none';
    });
  }

  function fixHomepageTypos() {
    var replacements = [
      ['Designersand', 'Designers and'],
      ["back to it's original glory", 'back to its original glory'],
      ['their brides.Check out', 'their brides. Check out'],
      ['Happily Every After', 'Happily Ever After'],
      ['is one the most affordable', 'is one of the most affordable'],
      ['as we seen and heard', 'as we have seen and heard'],
      ["and this it's such a convenient", 'and that it is such a convenient'],
      ['wont damage to your gown', "won't damage your gown"],
      ['I am please to say', 'I am pleased to say'],
      ['Thankyou so much', 'Thank you so much'],
      ['Taylors Lake, VIC', 'Taylors Lakes, VIC'],
    ];

    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var value = node.nodeValue;
      if (!value || !value.trim()) continue;
      var next = value;
      for (var i = 0; i < replacements.length; i++) {
        if (next.indexOf(replacements[i][0]) !== -1) {
          next = next.split(replacements[i][0]).join(replacements[i][1]);
        }
      }
      if (next !== value) node.nodeValue = next;
    }
  }

  function replaceElfsightReviews() {
    var embed = document.querySelector('.' + ELF_REVIEWS_CLASS);
    if (!embed) return false;

    var host = embed.closest('.shopify-section') || embed.parentElement;
    if (!host || host.dataset.mdbReviewsReplaced === 'true') return !!document.querySelector('.mdb-g-reviews');

    ensureStylesheet(CSS_HREF_PATH);
    ensureStylesheet(SLIDER_CSS_PATH);
    if (!document.getElementById('mdb-g-reviews-card-fallback')) {
      var s = document.createElement('style');
      s.id = 'mdb-g-reviews-card-fallback';
      s.textContent =
        '.mdb-g-reviews,.mdb-g-reviews-band{background:#ffffff!important;}' +
        '.mdb-g-reviews__review{background:#efecec!important;border-radius:6px!important;padding:2.5rem 1.75rem!important;box-sizing:border-box;}';
      document.head.appendChild(s);
    }

    var reviewsLink = '/pages/wedding-dress-cleaning-reviews';
    var mount = document.createElement('div');
    mount.className = 'color-background-2 gradient mdb-g-reviews-band';
    mount.style.background = '#ffffff';
    mount.innerHTML =
      '<div class="section-mdb-injected-reviews-padding" style="padding-top:40px;padding-bottom:52px;background:#ffffff">' +
      buildMarkup(reviewsLink) +
      '</div>';

    // Prefer replacing the whole custom-liquid section content area
    var paddingWrap = embed.closest('[class*="-padding"]');
    if (paddingWrap && paddingWrap.parentElement) {
      paddingWrap.parentElement.replaceChild(mount, paddingWrap);
    } else {
      embed.replaceWith(mount);
    }

    host.dataset.mdbReviewsReplaced = 'true';
    hideEmptyBridesHeading();
    initQuoteToggles(mount);
    fixHomepageTypos();

    // Hide any leftover min-height style tags targeting the elfsight app
    document.querySelectorAll('style').forEach(function (styleEl) {
      if ((styleEl.textContent || '').indexOf(ELF_REVIEWS_CLASS) !== -1) {
        styleEl.textContent = '';
      }
    });

    return true;
  }

  // Still lazy-load Elfsight only for other widgets (not the homepage reviews app)
  var SCRIPT_SRC = 'https://static.elfsight.com/platform/platform.js';
  var loading = false;
  var loaded = false;

  function loadPlatform() {
    if (loading || loaded) return;
    loading = true;
    var s = document.createElement('script');
    s.src = SCRIPT_SRC;
    s.async = true;
    s.setAttribute('data-use-service-core', '');
    s.onload = function () {
      loaded = true;
    };
    document.body.appendChild(s);
  }

  function watchOtherElfsight() {
    var nodes = document.querySelectorAll('[class*="elfsight-app-"]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].classList.contains(ELF_REVIEWS_CLASS)) continue;
      if (!('IntersectionObserver' in window)) {
        loadPlatform();
        return;
      }
      (function (el) {
        var io = new IntersectionObserver(
          function (entries) {
            for (var j = 0; j < entries.length; j++) {
              if (entries[j].isIntersecting) {
                io.disconnect();
                loadPlatform();
                break;
              }
            }
          },
          { rootMargin: '200px 0px' }
        );
        io.observe(el);
      })(nodes[i]);
    }
  }

  function init() {
    replaceElfsightReviews();
    hideEmptyBridesHeading();
    fixHomepageTypos();
    watchOtherElfsight();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* MDB: keep Google badge bottom-aligned with Shopify Inbox Live chat */
(function () {
  if (window.__mdbGBadgeAlign) return;
  window.__mdbGBadgeAlign = true;

  function chatNode() {
    var host = document.querySelector('shopify-chat');
    if (host) {
      try {
        if (host.shadowRoot) {
          var inner =
            host.shadowRoot.querySelector('[part="button"], button, [role="button"], a') ||
            host.shadowRoot.querySelector('[class*="activator"], [class*="launcher"], [class*="button"]');
          if (inner) return inner;
        }
      } catch (e) {}
      return host;
    }
    return document.querySelector('#shopify-chat, [id*="ShopifyChat"]');
  }

  function ensureSoftStyle() {
    if (document.getElementById('mdb-g-badge-align')) return;
    var style = document.createElement('style');
    style.id = 'mdb-g-badge-align';
    style.textContent =
      '.mdb-g-badge{background:rgba(255,255,255,.92)!important;-webkit-backdrop-filter:saturate(1.2) blur(10px);backdrop-filter:saturate(1.2) blur(10px);border:1px solid rgba(0,0,0,.08);box-shadow:0 1px 6px rgba(0,0,0,.1)!important;' +
      'bottom:var(--shopify-chat-activator-offset,80px)!important;}';
    (document.head || document.documentElement).appendChild(style);
  }

  function align() {
    ensureSoftStyle();
    var badge = document.querySelector('[data-mdb-g-badge], .mdb-g-badge');
    if (!badge) return;
    var chat = chatNode();
    if (!chat) return;
    var rect = chat.getBoundingClientRect();
    if (rect.width < 4 || rect.height < 4 || rect.bottom < 0) return;
    var bottom = Math.max(0, Math.round(window.innerHeight - rect.bottom));
    badge.style.setProperty('bottom', bottom + 'px', 'important');
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      align();
    });
  }

  function boot() {
    align();
    var tries = 0;
    var tick = setInterval(function () {
      align();
      tries += 1;
      if (tries > 40) clearInterval(tick);
    }, 250);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(schedule).observe(document.documentElement, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'style'],
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

